const doc = [({"en":({"js":({"admin":({"show_boxes":({"partial":({"attribute":({"the_attribute_was_deleted":"The attribute was deleted."})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;